import { memo } from 'react';

import Icon from 'components/shared/Icon/Icon';

const RightComponent = ({ timezone, icon, shouldShowIcon = true }) => (
  <div className="flex items-center gap-2">
    <span className="select-none whitespace-nowrap text-xs font-500 text-neutral-500">
      {timezone}
    </span>
    {shouldShowIcon && (typeof icon === 'object' ? icon : <Icon icon={icon} size={20} />)}
  </div>
);

export default memo(RightComponent);
